import { Typography } from '@material-ui/core'
import MaterialTable from 'material-table'
import React, { useEffect, useState } from 'react'
import CustomizedDialogs from '../dialog'
import GetAppIcon from '@material-ui/icons/GetApp';
import AddIcon from '@material-ui/icons/Add';
import VisibilityIcon from '@material-ui/icons/Visibility';
import EditIcon from '@material-ui/icons/Edit';
import GroupIcon from '@material-ui/icons/Group';
import { makeStyles } from "@material-ui/core/styles";
import ClientService from '../../services/ClientService'
import { toast } from "react-toastify";
import ClientForm from '../ClientForm'
import TypeClientService from '../../services/TypeClientService';
import { 
  Dialog, 
  DialogTitle, 
  DialogContent, 
  DialogActions, 
  Button, 
  Chip,
  Box,
  Tooltip
} from '@material-ui/core';
import ClientUpdateForm from '../ClientUpdateForm';

const useStyles = makeStyles({
  root: {
    maxWidth: 345,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    alignContent: 'center',
  },
  beneficiaireChip: {
    margin: '2px',
    fontSize: '0.75rem',
  },
  beneficiaireContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '4px',
    maxWidth: 200,
  },
  dialogContent: {
    minHeight: 200,
  },
  beneficiaireList: {
    maxHeight: 300,
    overflow: 'auto',
  },
  beneficiaireItem: {
    padding: '8px',
    borderBottom: '1px solid #e0e0e0',
    '&:last-child': {
      borderBottom: 'none',
    }
  }
});

const Client = () => {
  const classes = useStyles();
  const [formes, setFormes] = useState([])
  const [type, setType] = useState([])
  const [selectedClient, setSelectedClient] = useState(null);
  const [beneficiairesDialog, setBeneficiairesDialog] = useState(false);
  const [updateDialog, setUpdateDialog] = useState(false);

  const handleFilters = async (e) => {
    const value = e.target.value;
    await ClientService.getTypeClient(value)
      .then((response) => {
        var data = response.data
        setFormes(data)
      })
      .catch((error) => {
        console.log(error)
      })
  }

  useEffect(() => {
    const fetchData = async () => {
      await ClientService.getClient()
        .then((response) => {
          setFormes(response.data)
        })
        .catch(e => {
          console.log(e);
        });

      await TypeClientService.getTypeClient()
        .then((response) => {
          var data = response.data
          console.log("types === " + JSON.stringify(data))
          setType(data)
        })
        .catch((error) => {
          console.log(error)
        })
    }
    fetchData();
  }, [])

  const refreshFormes = async () => {
    await ClientService.getClient()
      .then((response) => {
        setFormes(response.data)
      })
      .catch(e => {
        console.log(e);
      });
  }

  const handleViewBeneficiaires = async (client) => {
    setSelectedClient(client);
    try {
      const response = await ClientService.getClientBeneficiaires(client[0]?.idClient);
      console.log("response")
      console.log(response)
      console.log("response")
      setSelectedClient(prev => ({
        ...prev,
        beneficiaires: response.data
      }));
      setBeneficiairesDialog(true);
    } catch (error) {
      console.error('Erreur chargement bénéficiaires:', error);
      toast.error("Erreur lors du chargement des bénéficiaires");
    }
  }

  const handleUpdateClient = (client) => {
    setSelectedClient(client);
    setUpdateDialog(true);
  }

  const handleCloseDialogs = () => {
    setBeneficiairesDialog(false);
    setUpdateDialog(false);
    setSelectedClient(null);
  }

  const columns = [
    { title: "ID", field: "idClient", filterPlaceholder: "filter" },
    { title: "REFERENCE", field: "reference", filterPlaceholder: "filter" },
    { title: "NOM", field: "nom", filterPlaceholder: "filter" },
    { title: "ADRESSE", field: "adresse", filterPlaceholder: "filter" },
    { title: "TELEPHONE", field: "telephone", filterPlaceholder: "filter" },
    { title: "QUOTA", field: `quota`, filterPlaceholder: "filter" },
    { title: "SOLDE", field: "solde", filterPlaceholder: "filter", editable: 'never' },
    { title: "REMISE", field: `remise`, filterPlaceholder: "filter" },
    { title: "TAUX IPM", field: `tauxIpm`, searchable: false, export: false },
    {
      title: "TYPE", field: "designation",
      render: (rowData) => <div style={{ background: rowData.designation === "INDIVIDUELS" ? "#008000aa" : rowData.designation === "AUTRES ENTITES" ? "#f90000aa" : "#CCC", borderRadius: "4px", paddingLeft: 5 }}>{rowData.designation}</div>,
      searchable: false, export: false
    },
    {
      title: "BÉNÉFICIAIRES",
      field: "beneficiaires",
      render: (rowData) => (
        <div className={classes.beneficiaireContainer}>
          {rowData.beneficiaires && rowData.beneficiaires.length > 0 ? (
            <>
              <Chip
                icon={<GroupIcon />}
                label={rowData.beneficiaires.length}
                size="small"
                className={classes.beneficiaireChip}
                color="primary"
                variant="outlined"
              />
              {rowData.beneficiaires.slice(0, 2).map((benef, index) => (
                <Chip
                  key={index}
                  label={`${benef.prenom}`}
                  size="small"
                  className={classes.beneficiaireChip}
                  variant="outlined"
                />
              ))}
              {rowData.beneficiaires.length > 2 && (
                <Chip
                  label={`+${rowData.beneficiaires.length - 2}`}
                  size="small"
                  className={classes.beneficiaireChip}
                />
              )}
            </>
          ) : (
            <Chip
              label="Aucun"
              size="small"
              className={classes.beneficiaireChip}
              variant="outlined"
            />
          )}
        </div>
      ),
      searchable: false,
      export: false,
      sorting: false
    },
    { title: "CREATEUR", field: "speudo", filterPlaceholder: "filter" },
  ]

  return (
    <div className="App" style={{ width: "100%", display: 'flow', justifyContent: 'center', alignItems: 'center', top: 0, bottom: 0, margin: 'auto' }}>
      <Typography variant="title" className={classes.title}>
        Liste des clients
      </Typography>
      <div style={{ display: "flex", justifyContent: 'flex-start', margin: 15 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
          <div>
            <CustomizedDialogs
              title="Nouveau Client"
              boutonTitle="Ajouter un client"
              icon="client"
              refresh={() => refreshFormes()}
            >
              <ClientForm />
            </CustomizedDialogs>
          </div>
          <div style={{ marginRight: '20px' }} >
            <select style={{ padding: '10px', marginLeft: '50px' }} name="color" onChange={handleFilters}>
              <option>
                Type Client
              </option>
              {
                type.map((type) => (
                  <option value={type.idType}>{type.designation}</option>
                ))
              }
            </select>
          </div>
        </div>
      </div>

      <MaterialTable
        columns={columns}
        data={formes}
        editable={{
          onRowAdd: (newRow) => new Promise((resolve, reject) => {
            ClientService.createClient(newRow)
              .then((response) => {
                toast.success("Client ajouté avec succès", {
                  position: toast.POSITION.BOTTOM_RIGHT,
                });
                refreshFormes()
              })
              .catch((error) => {
                console.log(error);
                toast.error(error.response?.data, {
                  position: toast.POSITION.BOTTOM_RIGHT,
                });
              });
            refreshFormes()
            setTimeout(() => resolve(), 500)
          }),
          onRowUpdate: (newRow, oldRow) => new Promise((resolve, reject) => {
            if (parseInt(oldRow.remise) + parseInt(newRow.tauxIpm) > 100) {
              toast.error("Pourcentage ne doit pas dépasser 100%", {
                position: toast.POSITION.BOTTOM_RIGHT,
              });
              setTimeout(() => resolve(), 100)
              return;
            }

            ClientService.updateClient(newRow, oldRow.idClient)
              .then((response) => {
                console.log(JSON.stringify(response));
                if (response?.data?.message === 'Ce type de client ne peut etre modifié') {
                  toast.error(response?.data?.message, {
                    position: toast.POSITION.BOTTOM_RIGHT,
                  });
                }
                else {
                  toast.success(response?.data?.message, {
                    position: toast.POSITION.BOTTOM_RIGHT,
                  });
                }
                refreshFormes()
              })
              .catch((error) => {
                console.log(error);
                toast.error(error.response?.data, {
                  position: toast.POSITION.BOTTOM_RIGHT,
                });
              });
            refreshFormes()
            setTimeout(() => resolve(), 500)
          }),
          onRowDelete: (selectedRow) => new Promise((resolve, reject) => {
            ClientService.deleteClient(selectedRow.idClient)
              .then((response) => {
                toast.success("Client supprimé avec succès", {
                  position: toast.POSITION.BOTTOM_RIGHT,
                });
                refreshFormes()
              })
              .catch((error) => {
                console.log(error);
                toast.error(error.response?.data?.message, {
                  position: toast.POSITION.BOTTOM_RIGHT,
                });
              });
            setTimeout(() => resolve(), 1000)
          })
        }}
        actions={[
          {
            icon: () => (
              <Tooltip>
                <VisibilityIcon color="primary" />
              </Tooltip>
            ),
            tooltip: "Voir les bénéficiaires",
            onClick: (event, rowData) => {
              handleViewBeneficiaires(rowData);
            },
          },
          {
            icon: () => (
              <Tooltip title="Modifier le client">
                <EditIcon color="secondary" />
              </Tooltip>
            ),
            onClick: (event, rowData) => {
              handleUpdateClient(rowData);
            },
          },
          {
            icon: () => <GetAppIcon />,
            tooltip: "Exporter",
            onClick: (event, rowData) => {
              console.log(rowData)
            },
          }
        ]}
        options={{
          sorting: true, search: true,
          searchFieldAlignment: "right", searchAutoFocus: true, searchFieldVariant: "standard",
          filtering: true, paging: true, pageSizeOptions: [2, 5, 10, 20, 25, 50, 100], pageSize: 5,
          paginationType: "stepped", showFirstLastPageButtons: false, paginationPosition: "both", exportButton: true,
          exportAllData: true, exportFileName: "Clients", addRowPosition: "first", actionsColumnIndex: -1, selection: true,
          showSelectAllCheckbox: false, showTextRowsSelected: false, selectionProps: () => ({
            color: "primary"
          }),
          columnsButton: true,
          rowStyle: (_data, index) => index % 2 === 0 ? { background: "#f5f5f5" } : null,
          headerStyle: { background: "#226D68", color: "#fff" },
        }}
        title="Liste des Clients"
        icons={{ Add: () => <AddIcon /> }}
      />

      {/* Dialog pour afficher les bénéficiaires */}
      <Dialog
        open={beneficiairesDialog}
        onClose={handleCloseDialogs}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          <Box display="flex" alignItems="center">
            <GroupIcon style={{ marginRight: 8 }} />
            Bénéficiaires de {selectedClient?.nom}
          </Box>
        </DialogTitle>
        <DialogContent className={classes.dialogContent}>
          <div className={classes.beneficiaireList}>
            {selectedClient?.beneficiaires && selectedClient.beneficiaires.length > 0 ? (
              selectedClient.beneficiaires.map((beneficiaire, index) => (
                <div key={index} className={classes.beneficiaireItem}>
                  <Box display="flex" justifyContent="space-between" alignItems="center">
                    <div>
                      <Typography variant="subtitle1" fontWeight="bold">
                        {beneficiaire.nom} {beneficiaire.prenom}
                      </Typography>
                      <Typography variant="body2" color="textSecondary">
                        Lien: {beneficiaire.lien_parente}
                        {beneficiaire.telephone && ` • Tél: ${beneficiaire.telephone}`}
                        {beneficiaire.date_naissance && ` • Naissance: ${beneficiaire.date_naissance}`}
                      </Typography>
                    </div>
                  </Box>
                </div>
              ))
            ) : (
              <Typography variant="body1" color="textSecondary" style={{ textAlign: 'center', padding: 20 }}>
                Aucun bénéficiaire enregistré pour ce client
              </Typography>
            )}
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialogs} color="primary">
            Fermer
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dialog pour modifier le client */}
      <Dialog
        open={updateDialog}
        onClose={handleCloseDialogs}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          Modifier le client {selectedClient?.nom}
        </DialogTitle>
        <DialogContent>
          {selectedClient && (
            <ClientUpdateForm 
              client={selectedClient} 
              onClose={handleCloseDialogs}
              onSuccess={() => {
                refreshFormes();
                handleCloseDialogs();
              }}
            />
          )}
        </DialogContent>
      </Dialog>
    </div>
  )
}

export default Client